import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid, Dialog, DialogContent } from "@material-ui/core";
import { Button, Text, SVG, TextArea } from "sunrise-ui";
import List from "./List";
// API CALLS
import { AppDispatch } from "../../redux/store";
import {
  getDiscardedPilesData,
  approveUndoDiscardPileId,
  rejectUndoDiscardPileId,
} from "../../redux/reducers/dashboardReducers";
import Loader from "../../utilities/Loader";
import toaster from "../../utilities/toaster";

const Discarded = (props: any) => {
  const dispatch = useDispatch<AppDispatch>();
  const [openModal, setOpenModal] = useState(false);
  const [histPileId, setHistPileId] = useState("");
  const [pileDataAndType, setPileDataAndType] = useState({
    id: "",
    type: "",
    name: "",
  });
  const [reason, setReason] = useState({
    value: "",
    error: false,
  });
  const [buttonLoading, setButtonLoading] = useState(false);
  const [dataToDownload, setDataToDownload] = useState([]);

  const allProject = useSelector((state: any) => state.PROJECT.allProjectData);
  const discardedPilesData = useSelector(
    (state: any) => state.DASHBOARD.discardedPilesData
  );
  // To get project id
  let project_id: any;
  if (Array.isArray(allProject)) {
    project_id = allProject?.find(
      (val: any) => val?.projectName === props?.projectName
    )?._id;
  }

  const reset = () => {
    setReason({ value: "", error: false });
    setPileDataAndType({
      id: "",
      type: "",
      name: "",
    });
    setHistPileId("");
  };

  const submitUndo = () => {
    if (reason.value !== "") {
      const data = {
        pileId: pileDataAndType.id,
        projectId: project_id,
        reason: reason.value,
        histPileId,
      };
      setOpenModal(false);
      setButtonLoading(true);
      if (pileDataAndType.type === "approve") {
        dispatch(
          approveUndoDiscardPileId({
            endPoint: `piles/approve-undo-request`,
            data,
          })
        ).then(() => {
          toaster(
            "success",
            "Undo discard pile has been approved successfully!"
          );
          setButtonLoading(false);
          getData();
          reset();
        });
      } else {
        dispatch(
          rejectUndoDiscardPileId({
            endPoint: `piles/reject-undo-request`,
            data,
          })
        ).then(() => {
          toaster(
            "success",
            "Undo discard pile has been rejected successfully!"
          );
          setButtonLoading(false);
          getData();
          reset();
        });
      }
    } else {
      setReason({ value: "", error: true });
    }
  };
  const getData = () => {
    if (project_id) {
      dispatch(
        getDiscardedPilesData({
          endPoint: `piles/get-discarded?projectId=${project_id}`,
        })
      );
    }
  };
  useEffect(()=>{
    let downloadData = discardedPilesData.map((ele:any)=>{
      return {
        'Pile Id': ele.pileName,
        'Work Started By':ele.workStartedBy,
        'Pile Discarded/Rejected By':ele.discardedRejectedBy,
        'Step Details':ele.discardedAtStep,
        'Pile Discarded/Rejected Reason':ele.discaredRejectedReason,
        'Pile Status':ele.pileStatus,
        'Undo Request Sent By':ele.undoRequestedBy,
        // 'Status':ele.workCompletedBy,
        'Undo Request Approve/Rejection reason':ele.undoApproveOrRejectReason,
      }
    })
    setDataToDownload(downloadData)
  },[discardedPilesData])
  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [props.projectName]);

  const fields = [
    {
      header: "Pile Id",
      value: "pileName",
    },
    {
      header: "Work Started By",
      value: "workStartedBy",
      search: true,
    },
    {
      header: "Pile Discarded/Rejected By",
      value: "discardedRejectedBy",
      search: true,
    },
    {
      header: "Step Details",
      search: true,
      value: "discardedAtStep",
    },
    {
      header: "Pile Discarded/Rejected Reason",
      value: "discaredRejectedReason",
      search: true,
      action: function (obj: any) {
        return (
          <Text
            type="normal"
            fonts="normal"
            className="mt0 mb0 fw400 fs14 reason-section"
          >
            {obj?.discaredRejectedReason}
          </Text>
        );
      },
    },
    {
      header: "Pile Status",
      value: "pileStatus",
      search: true,
      action: function (obj: any) {
        return (
          <Text
            type="normal"
            fonts="normal"
            className="mt0 mb0 fw400 fs14 capitalize"
          >
            {obj?.pileStatus}
          </Text>
        );
      },
    },
    {
      header: "Undo Request Sent By",
      value: "undoRequestedBy",
      search: true,
    },
    {
      header: "Action/Status",
      action: function (obj: any) {
        return (
          <div className="action_buttons_box d-flex v-center">
            {obj?.action !== "pending" ? (
              <Text
                type={"normal"}
                fonts="normal"
                className={`mb0 mt0 fw500 capitalize ${
                  obj?.action === "rejected"
                    ? "text--danger"
                    : obj?.action === "rejected" && "text--success"
                }`}
                fontSize={14}
              >
                {obj?.action}
              </Text>
            ) : (
              <div className="action_buttons_box d-flex v-center">
                <Button
                  type="button"
                  size="small"
                  isRounded={true}
                  category="success"
                  className="f14 mr-1"
                  onClick={() => {
                    setOpenModal(true);
                    setPileDataAndType({
                      id: obj?.id,
                      name: obj?.pileName,
                      type: "approve",
                    });

                    setHistPileId(obj?.histPileId);
                  }}
                >
                  {buttonLoading &&
                  pileDataAndType.id === obj.id &&
                  pileDataAndType.type === "approve" ? (
                    <Loader
                      color="white"
                      loading={buttonLoading}
                      size={6}
                      height="auto"
                    />
                  ) : (
                    "Approve"
                  )}
                </Button>
                <Button
                  type="button"
                  size="small"
                  isRounded={true}
                  category="warning"
                  className="f14"
                  onClick={() => {
                    setOpenModal(true);
                    setPileDataAndType({
                      id: obj?.id,
                      name: obj?.pileName,
                      type: "reject",
                    });

                    setHistPileId(obj?.histPileId);
                  }}
                >
                  {buttonLoading &&
                  pileDataAndType.id === obj.id &&
                  pileDataAndType.type === "reject" ? (
                    <Loader
                      color="white"
                      loading={buttonLoading}
                      size={6}
                      height="auto"
                    />
                  ) : (
                    "Reject"
                  )}
                </Button>
              </div>
            )}
          </div>
        );
      },
    },
    {
      header: "Undo Request Approve/Rejection reason",
      value: "undoApproveOrRejectReason",
      search: true,
      action: function (obj: any) {
        return (
          <Text
            type="normal"
            fonts="normal"
            className="mt0 mb0 fw400 fs14 reason-section"
          >
            {obj?.undoApproveOrRejectReason}
          </Text>
        );
      },
    },
  ];

  return (
    <div>
      <Grid container>
        <List
          listData={discardedPilesData}
          dataToDownLoad={dataToDownload}
          fields={fields}
          title={`Discarded/Rejected Pile Details`}
          sizeType="large"
          nodataText="No Piles are Discarded/Rejected"
          project={props.projectName}
        />
      </Grid>

      <Grid>
        <Dialog
          onClose={() => setOpenModal(false)}
          aria-labelledby="simple-dialog-title"
          open={openModal}
          maxWidth="sm"
        >
          <DialogContent>
            <Text
              type="normal"
              fonts="normal"
              className="mt0 mb0 d-flex sb"
              fontSize={16}
            >
              <span>
                {`Are you sure you want to ${pileDataAndType.type} the`}
                <br />
                undo request for pileid {pileDataAndType.name} ?
              </span>
              <Text
                type="normal"
                fonts="normal"
                className="mt0 mb0 dflex_between pointer"
                fontSize={16}
                onTextClick={() => setOpenModal(false)}
              >
                <SVG type="close" />
              </Text>
            </Text>
            <div className="discard_wrapper">
              <Text
                type="normal"
                fonts="normal"
                className="mt0 mb0 fw400"
                fontSize={16}
              >
                <span>
                  Reason<sup>*</sup>
                </span>
              </Text>
              <TextArea
                name="reason"
                placeholder="Write description here"
                value={reason.value}
                onChange={(e) => {
                  let obj = { ...e };
                  setReason({
                    value: obj.target.value,
                    error: false,
                  });
                }}
                borderColor={reason.error === true ? "danger" : "primary"}
              />
              <Grid className="d-flex h-center">
                <Button
                  type="button"
                  size="medium"
                  isRounded={true}
                  category="primary"
                  className="f14 fw500 mt1 mr-2 sbt"
                  onClick={submitUndo}
                >
                  Yes
                </Button>
                <Button
                  type="button"
                  size="medium"
                  isRounded={true}
                  category="border-only"
                  className="f14 fw500 mt1 sbt"
                  onClick={() => {
                    setOpenModal(false);
                    setReason({ value: "", error: false });
                    setPileDataAndType({ id: "", type: "", name: "" });
                  }}
                >
                  No
                </Button>
              </Grid>
            </div>
          </DialogContent>
        </Dialog>
      </Grid>
    </div>
  );
};

export default Discarded;
